import React, {Component} from 'react'
import classNames from 'classnames'
import Waypoint from 'react-waypoint'
import ArticleHeader from '../ArticleHeader/ArticleHeader'
import ArticleAside from '../ArticleAside'
import ArticleBody from '../ArticleBody/ArticleBody'
import SocialShareOptions from '../SocialShareOptions/SocialShareOptions'
import ArticleMeta from '../ArticleMeta/ArticleMeta'
import {getHostedImage, IMAGE_SIZE_LARGE, IMAGE_SIZE_ARTICLE_THUMBNAIL_LARGE_MOBILE} from '../../utils/images'

class Article extends Component {
  constructor (props) {
    super(props)
    this.handleOnPositionChange = this.handleOnPositionChange.bind(this)
  }

  getImageSize () {
    const {isMobileLayout} = this.props
    return isMobileLayout ? IMAGE_SIZE_ARTICLE_THUMBNAIL_LARGE_MOBILE : IMAGE_SIZE_LARGE
  }

  getHeaderImageStyle () {
    const {article} = this.props
    if (!article.previewImage) {
      return {}
    }
    return {
      backgroundImage: `url(${getHostedImage(article.previewImage.url, this.getImageSize())})`
    }
  }

  handleOnPositionChange (position) {
    const {setArticlePagePassedSocialWaypoint} = this.props
    if (position.currentPosition === 'above') {
      setArticlePagePassedSocialWaypoint(true)
    } else {
      setArticlePagePassedSocialWaypoint(false)
    }
  }

  renderBody () {
    return (
      <ArticleBody article={this.props.article} />
    )
  }

  getCaptionCitation () {
    const {
      article: {
        previewImage: {
          caption,
          citation
        }
      }
    } = this.props
    if (caption || citation) {
      return (
        <div className='Article__captionCitation'>
          {caption ? <div className='Article__caption'>{caption}</div> : null}
          {citation ? <cite className='Article__citation'>{citation}</cite> : null}
          <div className='Article__captionCitationClear' />
        </div>
      )
    }
  }

  getAltText (article) {
    return (article && article.previewImage && article.previewImage.altText) || ''
  }

  render () {
    const {article, contentType, relatedArticles} = this.props
    const ariaLabel = {
      'aria-label': this.getAltText(article)
    }
    return (
      <main className='Article'>
        <ArticleMeta article={article} />
        <ArticleHeader article={article} />
        <div className='Article__headerImage' role='img' {...ariaLabel} style={this.getHeaderImageStyle()} />
        {this.getCaptionCitation()}
        <div className='Article__content'>
          <div className='Article__main'>
            <div className='Article__main__mobileSocial'>
              <Waypoint
                onPositionChange={this.handleOnPositionChange}
              />
              <div className='ArticleAside__category__title' style={{whiteSpace: 'nowrap'}}>Share This Article</div>
              <SocialShareOptions article={article} />
            </div>
            {this.renderBody()}
          </div>
          {/* <div className={classNames([
            'Article__aside',
            `Article__aside--type-${contentType}`
          ])}>
            <ArticleAside article={article} articles={relatedArticles} />
          </div> */}
        </div>
      </main>
    )
  }
}

Article.defaultProps = {}

export default Article



// WEBPACK FOOTER //
// ./client/components/Article/Article.js